module.exports = __webpack_public_path__ + "static/media/water-circular.7183eab1.png";